const NotFound = () => {

    return (
        <div className='grid-container'>
            The page you've requested does not exist
        </div>
    )
}

export default NotFound